import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const boot = async () => {
      if (!getToken()) { setHydrated(true); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setToken(null);
      } finally {
        setHydrated(true);
      }
    };
    boot();
  }, []);

  const login = async (email, password, expectedRole) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (expectedRole && data.user.role !== expectedRole) {
        return { ok: false, error: `This is not a ${expectedRole} account.` };
      }
      setToken(data.access_token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Login failed" };
    }
  };

  const signup = async (form) => {
    try {
      const { data } = await api.post("/auth/signup", form);
      setToken(data.access_token);
      setUser(data.user);
      return { ok: true, user: data.user, devCodes: data.dev_codes };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Signup failed" };
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, refresh, hydrated }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
